<template lang="html">
    <data-table
        :headers="datatable.headers"
        :toolbar="datatable.toolbar"
        :actions="datatable.actions"
        :endpoint="datatable.endpoint"
        @rowClick="rowClick"
        storeId="comments"
        ref="list"
    >
        <template slot="items" slot-scope="props">
            <td class="text-xs-left author">
                <avatar :item="props.item" field="photo"></avatar>
                {{props.item.label}}
            </td>
            <td class="text-xs-right">
                {{props.item.code}}
            </td>
        </template>

    </data-table>
</template>

<script>
import DataTable from '../../../components/DataTable.vue'
import moment from 'moment'
import Avatar from '../../../components/avatar/Avatar.vue'

export default {
	components: { DataTable, Avatar },

	data() {
		return {
		    moment,
			datatable: {
				headers: [
					{ text: 'Nom', sortable: true, value: 'label', align: 'left' },
					{ text: 'Code', sortable: true, value: 'code', align: 'right' }
				],
				endpoint: {
					base: '/api/products',
					filters: `parents.linked_product.product_id|=|${this.$route.params.id},group|=|component`
				}
			},
            hide_demand : false
		}
	},
	methods: {
        rowClick(item){

        }
	},
	created() {
		this.$eventHub.$on('reload-list', () => {
			if (this.$refs.list) {
				this.$refs.list.reload()
			}
		})
	},
    mounted() {

    }
}
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/views/products/single/Components.vue